import React from 'react';

const LineDelimiter = () => {
  return <div className="h-[1px] w-full bg-gray-200" />;
};

export default LineDelimiter;
